module.exports = __webpack_public_path__ + "img/talron-menu-logout.6999b5b4.svg";